import type { CmsSignpost } from '@gov-nx/api';
import { prop } from '@gov-nx/core/types';
import { usePersistedStore } from '../constants';
import type { SignpostState } from './store.types';

const initialState = {
	signposts: [],
};

const useStore = <T>(selector: (state: SignpostState) => T) =>
	usePersistedStore(
		(set) => ({
			...initialState,

			saveSignposts: (signposts: CmsSignpost[]) => set({ signposts }),
		}),
		'signpost',
		selector
	);

export const useSignpostStore = <T extends keyof SignpostState>(
	property: T
): SignpostState[T] => useStore(prop(property));
